module.exports = __webpack_public_path__ + "img/PD1504760969606332416.7a7e3ad0.png";